import { Timestamp, GeoPoint, DocumentReference } from "firebase/firestore";

interface Geometry {
  location: {
    lat: () => number;
    lng: () => number;
  };
  viewport: {
    northeast: {
      lat: number;
      lng: number;
    };
    southwest: {
      lat: number;
      lng: number;
    };
  };
}

interface PlaceResult {
  formatted_address: string;
  geometry: Geometry;
  icon: string;
  name: string;
  place_id: string;
  types: string[];
  address_components: Array<{ long_name: string; short_name: string }>;
}

export type SearchCityResult = {
  position: LatLng;
  name: string;
  longName: string;
};

export type CreateUser = {
  name: string;
  place: SearchCityResult;
};

export type CreateError = {
  name: string;
  message: string;
};

export type FirebaseUser = {
  created_time: Timestamp;
  display_name: string;
  email: string | null;
  verified_email: boolean | null;
  uid: string;
  tot_points: number;
  photo_url: string | null;
  num_reviews: number;
  new_badge: boolean;
  migrated: boolean;
  is_reviewer: boolean;
  cityName: string;
  city: GeoPoint;
  coupon?: boolean | null;
  badges?: Array<{
    created_time: Timestamp;
    description: string;
    earned_time: string;
    image: string;
    name: string;
    points: number;
  }>;
  badges_ref?: Array<string>;
};

export type CreatePost = {
  title: string;
  caption: string;
  video: File;
  rating: number;
};
export type FoodCourt = {
  name: string;
  description: string;
  website: string;
  menuLink: string;
  style: {
    primaryColor: string;
  };
};

export type Post = {
  place_ref: DocumentReference;
  status: string;
  order: number;
  place_name: string;
  place_image: string;
  place_pos: GeoPoint;
  caption?: string;
  title: string;
  user_image: string | null;
  // video_url: string; // Rimosso: ora si usa solo BunnyNet
  created_by: DocumentReference;
  created_time: Timestamp;
  views: number;
};

export type Place = {
  id: number;
  address: string;
  image: string;
  name: string;
  phone_number?: string;
  website: string;
};

export type AppCurrentUser = {
  id: number;
  points: number;
  email: string;
  createdAt: Date;
  updatedAt: Date;
  referral: string;
  displayName: string;
  photoUrl: string;
};

export type LatLng = {
  latitude: number;
  longitude: number;
};

export interface BunnyNetCollectionsResponse {
  totalItems: number;
  currentPage: number;
  itemsPerPage: number;
  items: BunnyNetCollection[];
}

export interface BunnyNetCollection {
  videoLibraryId: number;
  guid: string;
  name: string;
  videoCount: number;
  totalSize: number;
  previewVideoIds: string;
  previewImageUrls: string[];
}

export type CouponNotification = {
  event_type: string;
  restaurant_id: number;
  review_id: number;
  timestamp: string;
};

export type Coupon = {
  code: string;
  expires_at: string;
};

export type CouponResponse = {
  isValid: boolean;
  coupon: Coupon;
};

export enum Status {
  Approved = "approved",
  Pending = "pending",
  Rejected = "rejected",
  Deleted = "deleted",
  DeletedNotApproved = "deleted_not_approved",
}

export type User = {
  id: number;
  display_name?: string;
  photo_url?: string;
  email: string;
  uid: string;
  referral: string;
  created_at: string;
  updated_at: string;
  city?: string;
  points: number;
  stats?: {
    review_count: number;
    approved_review_count: number;
    pending_review_count: number;
    rejected_review_count: number;
    reviewed_cities_count: number;
  };
  referrer?: User;
};

export type Review = {
  description?: string;
  created_at: string;
  id: number;
  status:
    | Status.Approved
    | Status.Rejected
    | Status.Pending
    | Status.Deleted
    | Status.DeletedNotApproved;
  thumbnail_url?: string;
  video_url: string;
  bunnynet_video_id?: string;
  title?: string;
  restaurant: Place;
  reviewer: User;
};
